import { STATES } from '../constants/constants';
export default (Vue) => {
  Vue.config.productionTip = false;

  Vue.prototype.$eventHub = new Vue(); // Global event bus

  Vue.prototype.$ponceConfig = {

    checkStatus (state) {
      switch (state) {
        case STATES.IRRIGATING:
          return '#00d166';
        case STATES.MOVING:
          return '#4F5AB0';
        case STATES.OFF:
          return '#999';
        case STATES.FAILURE:
          return '#f93a2f';

      }
    },
    organizationDemoId: 999,
    sortByEntityName (array) {
      return array.sort(function (a, b) {
        if (a.campaign.entityName < b.campaign.entityName) { return -1; }
        if (a.campaign.entityName > b.campaign.entityName) { return 1; }
        return 0;
      });
    },
    numberRules: [
      v => !!v || 'El campo es requerido',
      v => /^[+]?\d+([.]\d+)?$/.test(v) || 'Solo números por favor'
    ],
    phoneRules: [
      v => !!v || 'El teléfono es requerido',
      v => /^[+]{1}[0-9]{13}$/.test(v) || 'Formato requerido: +549223XXXXXXX'
    ],
    requiredRules: [
      v => !!v || 'Este campo es requerido'
    ],
    /* latLonRules: [
      v => !!v || 'La latitud y Longitud es requerida',
      v => /^(\-?\d+(\.\d+)?).\s*(\-?\d+(\.\d+)?)$/.test(v) || 'Formato requerido: (-)38.002625'
    ], */
    numberOptionalRules: [
      v => /^[+]?\d+([.]\d+)?$/.test(v) || 'Solo números por favor'
    ],
    passwordRules: [
      v => !!v || 'La contraseña es requerida',
      v => (v && v.length >= 8) || 'La contraseña debe contener al menos 8 caracteres'
    ],
    emailRules: [
      v => !!v || 'El e-mail es requerido',
      v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'El e-mail debe ser valido'
    ],
    lotNameRules: [
      v => !!v || 'El nombre es requerido',
      v => (v && v.length <= 21) || 'El nombre no puede superar los 21 caracteres'
    ],
    equipmentNameRules: [
      v => !!v || 'El nombre es requerido',
      v => (v && v.length <= 16) || 'El nombre no puede superar los 16 caracteres'
    ],
    organizationTypes: [
      { text: 'Productor', value: 'grower' },
      { text: 'Empresa', value: 'company' },
      { text: 'Corporación', value: 'corporation' }
    ],
    deviceMode: [
      { text: 'Activo', value: true },
      { text: 'Inactivo', value: false }
    ],
    equipmentTypes: [
      { text: 'Pivot', value: 1 },
      { text: 'Avance Frontal', value: 2 }
    ]
  };
};



// WEBPACK FOOTER //
// ./src/constants/config.js